<template>
  <div id="app">
    <!-- 顶部环境光晕层 -->
    <div class="tech-ambient-glow tech-glow-top"></div>
    <div class="tech-ambient-mesh"></div>
    
    <!-- 路由主视口 -->
    <div class="app-main-content">
      <router-view></router-view>
    </div>

    <!-- 底部环境光晕层 -->
    <div class="tech-ambient-glow tech-glow-bottom"></div>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style lang="scss">
@import "@/assets/custom_theme.scss";

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2D1C12;
  background-color: #FFFBF7;
  background-image: 
    radial-gradient(ellipse 90% 45% at 50% -5%, rgba(255, 179, 107, 0.45) 0%, rgba(255, 237, 218, 0.25) 60%, transparent 80%),
    radial-gradient(ellipse 70% 35% at 50% 105%, rgba(255, 153, 51, 0.22) 0%, rgba(255, 220, 160, 0.12) 50%, transparent 75%),
    linear-gradient(180deg, #FFFBF7 0%, #FFF5EC 40%, #FFEEDD 100%);
  min-height: 100vh;
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  overflow-x: hidden;
  box-shadow: 0 0 50px rgba(255, 119, 0, 0.08);
}

/* 顶部与底部阳光暖橙与生活手账氛围 (浅色柔和漫射) */
.tech-ambient-glow {
  position: fixed;
  pointer-events: none;
  z-index: 0;
  border-radius: 50%;
  filter: blur(60px);
}

.tech-glow-top {
  top: -120px;
  left: 50%;
  transform: translateX(-50%);
  width: 360px;
  height: 280px;
  background: radial-gradient(circle, rgba(255, 175, 75, 0.55) 0%, rgba(255, 120, 30, 0.22) 45%, rgba(255, 215, 150, 0.12) 65%, transparent 75%);
}

.tech-glow-bottom {
  bottom: -100px;
  left: 50%;
  transform: translateX(-50%);
  width: 380px;
  height: 240px;
  background: radial-gradient(circle, rgba(255, 150, 50, 0.32) 0%, rgba(255, 205, 140, 0.16) 50%, transparent 70%);
}

/* 暖橙微细网格纹理 (浅色半透) */
.tech-ambient-mesh {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 500px;
  margin: 0 auto;
  pointer-events: none;
  z-index: 0;
  opacity: 0.28;
  background-image: 
    radial-gradient(rgba(255, 119, 0, 0.14) 1px, transparent 1px),
    repeating-linear-gradient(45deg, rgba(255, 119, 0, 0.025) 0, rgba(255, 119, 0, 0.025) 1px, transparent 0, transparent 40px);
  background-size: 24px 24px, auto;
}

.app-main-content {
  position: relative;
  z-index: 1;
}
</style>
